export const FunctionNames =  {
    GetCategoriesByCategoryId: 'GetCategoriesByCategoryId',
    GetItemsByCategoryId: 'GetItemsByCategoryId',
    GetItemByItemId: 'GetItemByItemId',
    GetAllTeamMembers: 'GetAllTeamMembers',
    GetAllBlogPosts: 'GetAllBlogPosts',
    UpsertBlogPost: 'UpsertBlogPost',
    DeleteBlogPostById: 'DeleteBlogPostById',
    GetAllCalendarEvents: 'GetAllCalendarEvents',
    UpsertCalendarEvent: 'UpsertCalendarEvent',
    DeleteCalendarEventById: 'DeleteCalendarEventById',
    UploadImage: 'UploadImage',
    GetBlogPostById: 'GetBlogPostById'

}